import type { Idea } from '../interfaces/Idea';
import { API_BASE_URL } from '../services/apiClient';

const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;

const resolveUploadedImageSrc = (idea: Idea, content: string) => {
  const baseSrc = `${API_BASE_URL}/boardIdeas/image/${idea.topic}/${idea.id}`;

  if (!content) {
    return baseSrc;
  }

  return `${baseSrc}?v=${encodeURIComponent(content)}`;
};

export const resolveIdeaImageSrc = (idea: Idea) => {
  const content = idea.content?.trim() ?? '';

  if (!content) {
    return resolveUploadedImageSrc(idea, content);
  }

  if (
    ABSOLUTE_URL_PATTERN.test(content) ||
    content.startsWith('data:') ||
    content.startsWith('blob:')
  ) {
    return content;
  }

  return resolveUploadedImageSrc(idea, content);
};
